import { formatDate, getDaysBetweenDates } from '../../../../lib/date';

const getRestDays = (startDate, endDate) => {
  const today = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  return getDaysBetweenDates(start < today ? today : start, end) + 1;
};

const Item = ({ item, handleSelectChallenge, status }) => {
  return (
    <button
      className='w-full border border-tertiary rounded-xl px-2 py-2 flex items-center gap-2 bg-secondary'
      onClick={handleSelectChallenge}
    >
      <div className='w-16 h-16'>
        <img
          src={item.bannerUrl}
          alt='challenge'
          className='rounded-xl w-full h-full object-cover'
        />
      </div>
      <div className='flex-1 text-left space-y-1'>
        <h2 className='leading-5 text-white'>{item.title}</h2>
        <div>
          <div>
            <div className='text-xs opacity-40 text-white'>
              {formatDate(new Date(item.startDate))} -{' '}
              {formatDate(new Date(item.endDate))}
            </div>
            <div className='flex items-center gap-2'>
              {(status === 'CURRENT' || status === 'SCHEDULED') && (
                <div className='text-xs opacity-40 text-white'>
                  {getRestDays(item.startDate, item.endDate) === 0
                    ? 'The last day'
                    : `${getRestDays(item.startDate, item.endDate)} days left`}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {handleSelectChallenge && <div className='text-2xl text-white'>›</div>}
    </button>
  );
};

export default Item;
